// extracted by mini-css-extract-plugin
module.exports = {"noBroadcasts":"Broadcasts_noBroadcasts__cdZXC","messageCommunity":"Broadcasts_messageCommunity__6MZ7M"};